<template>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
        <h5>{{ show_name }} Vehicle</h5>
        <hr />
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-4" style="margin-top: 1%">
            <span class="p-float-label">
              <InputText
                id="search_number"
                type="text"
                v-model="search_number"
              />
              <label for="search_number">Enter Registration Number</label>
            </span>
          </div>
          <div class="field col-12 md:col-2" style="margin-top: 1%">
            <Button
              
              icon="pi pi-search"
              v-tooltip.bottom="'Search'"
              @click="search_vehicle()"
            />
          </div>
        </div>
      </div>
      <div class="card">
        <loading
          :active="isLoadingModel"
          :can-cancel="true"
          color="#173EA3"
          :is-full-page="fullPage"
        ></loading>
        <div class="col-12 md:col-12" v-if="search_status == true">
          No Details Found
        </div>
        <div
          style=" color:white; background-color: #173EA3; font-size: 12px; line-height: 0.9"
          class="card mb-0 grid"
          v-for="(data1, key) in driver_list1"
          :key="key"
        >
          
        <div style="text-align: right" class="col-12 md:col-12">
            <span>Status : </span
            ><span v-if="data1.status == 'Active' || data1.status == 'active'"
              ><badge :value="data1.status" severity="success"></badge
            ></span>
            <span
              v-else-if="
                data1.status == 'InActive' || data1.status == 'In Active'
              "
              ><badge :value="data1.status" severity="warning"></badge
            ></span>
            <span
              v-else-if="data1.status == 'Delete' || data1.status == 'Deleted'"
              ><badge :value="data1.status" severity="danger"></badge
            ></span>
            <span v-else>-</span>
            <!-- {{data1}} -->
          </div>

          <div style="text-align: left" class="col-12 md:col-12" >
            
			      <h4>Vehicle Details</h4>
          </div>
          <div class="col-12 md:col-2">
            <img
              style="max-width: 70px; height: 70px; border-radius: 50%"
              :src="
                data1.vehicle_photo
                  ? data1.vehicle_photo
                  : 'https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o='
              "
            />
          </div>
          <div class="grid col-12 md:col-10">
          <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-4">
                <span>Registration No : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <span style="text-align: right"
                  ><b v-if="data1.registration_number">{{ data1.registration_number }}</b> </span
                >
              </div>
            </div>
            <div class="grid col-12 md:col-4">
              <div class="col-6 md:col-6">
                <span>Vehicle Type : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <b>{{ data1.vehicle_type }}</b>
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-4">
                <span>RC Number : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <b>{{ data1.rc_number }}</b>
              </div>
            </div>  
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-4">
                <span>PUC Validity : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <b>{{ data1.puc_validity }}</b>
              </div>
            </div>
			</div>

        

          <div style="text-align: left" class="col-12 md:col-12"><hr>
            <h4>Owner Details</h4>
          </div>
          
          <div class="col-12 md:col-2">
            <img
              style="max-width: 70px; height: 70px; border-radius: 50%"
              :src="
                data1.owner_photo != ''
                  ? data1.owner_photo
                  : 'https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o='
              "
            />
          </div>
          <div class="grid col-12 md:col-10">
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-4">
                <span>Owner Name : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <span style="text-align: left"
                  ><b v-if="data1.owner_name">{{
                    data1.owner_name.toUpperCase()
                  }}</b>
                </span>
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-4">
                <span>Mobile Number : </span>
              </div>
              <div class="col-6 md:col-2" style="text-align: left">
                <b>{{ data1.owner_mobile_number }}</b>
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-4">
                <span>Email id : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <b>{{ data1.owner_email_id }}</b>
              </div>
            </div>
          </div>
          <div style="text-align: left" class="col-12 md:col-12">
            <hr />
            <h4>Driver Details</h4>
          </div>

          <div class="col-12 md:col-2">
            <img
              style="max-width: 70px; height: 70px; border-radius: 50%"
              :src="
                data1.driver_photo != ''
                  ? data1.driver_photo
                  : 'https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o='
              "
            />
          </div>
          <div class="grid col-12 md:col-10">
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-4">
                <span>Driver Name : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <span style="text-align: left"
                  ><b v-if="data1.driver_name">{{
                    data1.driver_name.toUpperCase()
                  }}</b>
                </span>
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-4">
                <span>Mobile Number : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <b>{{ data1.driver_mobile_number }}</b>
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-4">
                <span>Email id : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <b>{{ data1.driver_email_id }}</b>
              </div>
            </div>
            <!-- <div class="col-6 md:col-6">
							<span>Model : </span><b>{{data.vehicledetails[0].model}}</b>
						</div> -->
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-4">
                <span>DL Number : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <b v-if="data1.dldetails">{{ data1.dldetails.dl_number }}</b>
              </div>
            </div>

            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-4">
                <span>Dl Expiry Date : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <b v-if="data1.dldetails">{{
                  data1.dldetails.dl_expiry_date
                }}</b>
              </div>
            </div>

            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-4">
                <span>accidental_history </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <b v-if="data1.dldetails">{{
                  data1.dldetails.accidental_history
                }}</b>
              </div>
            </div>

            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-4">
                <span>24/7 Avaibility </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <b v-if="data1.dldetails">{{
                  data1.dldetails.available24by7
                }}</b>
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-4">
                <span>Shift time from</span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <b v-if="data1.dldetails">{{
                  data1.dldetails.shift_time_from
                }}</b>
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-4">
                <span>Shift time to</span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <b v-if="data1.dldetails">{{
                  data1.dldetails.shift_time_to
                }}</b>
              </div>
            </div>
            <div class="grid col-12 md:col-12">
              <div class="col-6 md:col-4">
                <span>Accidental Discription : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: left">
                <b v-if="data1.dldetails">{{
                  data1.dldetails.accidental_discription
                }}</b>
              </div>
            </div>
          </div>
          
          <div style="text-align: left" class="col-12 md:col-12">
            <hr />
            <div class="p-fluid formgrid grid">
              <div class="field col-12 md:col-6" style="margin-top: 1%">
                <span class="p-float-label">
                  <Dropdown
                    id="status" filter
                    v-model="selectgroupstatus"
                    :options="groupdropdownItems"
                    :value="groupdropdownItems.value"
                    optionLabel="name"
                    placeholder="Select One"
                    required="true"
                  ></Dropdown>
                  <label for="status">Route List</label>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-4" style="margin-top: 1%"></div>

          <div class="field col-12 md:col-4" style="margin-top: 1%">
            <Button
              :disabled="search_status == true"
              label="Hire"
              v-tooltip.bottom="'Hire'"
              @click="Hire_vehicle"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import InputValidation from '../service/InputValidation';
import BreadcrumbService from "../service/BreadcrumbService";
import JsonExcel from "vue-json-excel";
import apis from "@/apis";
export default {
  data() {
    return {
      groupdropdownItems: [],
      selectgroupstatus: null,
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,

      id: "",

      show_name: "Hire",

      product: {},
      submitted: false,
      search_status: true,
      search_loading: false,
      search_number: "",

      display3: false,
      driver_list1: [],
      display1: false,
      BreadcrumbService : null,
breadcrumbHome: {},
breadcrumbItems: [],
    };
  },
  productService: null,
  methods: {
    search_vehicle() {

      if (this.InputValidation.empty(this.search_number)==true) 
            {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Registration Number",
                    life: 3000,
                });
                return false;
            }
      var data = {
        registration_number: this.search_number,
      };
      this.isLoadingModel = true;
      var promise = apis.searchhireVehicleAdd(data);
      promise.then((response) => {
        this.isLoadingModel = false;
        if (response.data.status==false) {
          this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: response.data.message,
                    life: 3000,
                });
          this.search_number='';
          return false;
        }
        this.driver_list1 = response.data.data;
        // alert(search_result.length);
        if (this.driver_list1.length == 0) {
          this.search_status = true;
        } else {
          this.search_status = false;
        }
      });
    },
    dateFormatYMD(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);

          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return year + "-" + month + "-" + date;
          }
        }
      } else {
        return "";
      }
    },
    Hire_vehicle() {
      this.submitted = true;
        if (this.selectgroupstatus==null || this.selectgroupstatus.value=='' || this.selectgroupstatus.value==undefined) 
        {
            this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select Route",
            life: 3000,
          });
          return false;
        }
      var data = {
        group_id: this.selectgroupstatus.value,
        vehicle_id: this.driver_list1[0]._id,
        created_by: this.id,
      };

      console.log(data);

      this.isLoadingModel = true;
      var promise1 = apis.mappedVehcielGroup(data);
      promise1
        .then((responseapi) => {
          responseapi.data.status == true
            ? this.$swal("Hire Vehicle Successfully")
            : this.$swal("Vehicle Already Hired.");

          this.isLoadingModel = false;
          this.reset_user();
        })
        .catch((error) => {
          //console.log(error);
          this.isLoadingModel = false;
          this.$swal.fire(error.response.data);
        });
    },

    reset_user() {
      this.product = {};
      this.submitted = false;
      this.driver_list1=[];
      this.selectgroupstatus = null;
      this.search_number='';    
      this.search_status = true;

    },
    get_group_type_master() {
      this.loading = true;
      var data = {
        count: false,
        client_id: localStorage.getItem("client_id")
          ? localStorage.getItem("client_id")
          : "",
      };
      var promise = apis.groupList(data);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x]._id,
            });
          }
          this.groupdropdownItems = temp_data;
        }
      });
    },
  },
  async created() {
    this.productService = new ProductService();
    this.InputValidation = new InputValidation();
    // console.log(this.InputValidation.emailreg("a@gmail.com"));     if false show error!!!!
    this.id = localStorage.getItem("id");
    this.get_group_type_master();

    this.BreadcrumbService = new BreadcrumbService();
	let Breadcrum_data = this.BreadcrumbService.hire_vehicle()
	this.breadcrumbHome=Breadcrum_data.home;
	this.breadcrumbItems=Breadcrum_data.items;
  },

  components: { downloadExcel: JsonExcel },
};
</script>
